module.exports = __webpack_public_path__ + "media/dashboard/assets/images/mobile-chart-line-01-7373022ddaeff8d98a56a1d418da9c47.svg";